const quyenTruyCap = (state = [], action) => {
    switch(action.type){
        case "SET_QUYEN":
            return  action.payload
        case "DELETE_QUYEN":
            return []
        default:
            return state
    }
}

export default quyenTruyCap;